import { NumberCoercible } from '../utils/NumberCoercible';
import { compactNumberFormatter } from './compactNumberFormatter';
/**
 * A default tick formatter for use with scale ticks.
 */
export const defaultTickFormatter = (v: NumberCoercible, locale?: string): string => compactNumberFormatter(v, locale);
